export default function (error) {
    if (error.response) {
        return "Server error occurred. If you are facing repeated errors, please report us.";
    } else if (error.request) {
        return "Something went wrong. Please check your network connection and try again.";
    } else {
        return error.message;
    }
}
